export const INSURANCE_QUERY_KEY = {
  CHART: 'insurance-chart',
  STATS: 'insurance-stats',
  STATS_BREAKDOWN: 'insurance-stats-breakdown',
  CONTRACT_BY_PLANT: 'insurance-contract-by-plant',
  CONTRACT_BY_REGION: 'insurance-contract-by-region',
} as const;
